import { object, string } from 'yup';

export const schemaFilter = object().shape({
  taxId: string().when('$voen', ([voen], schema) => {
    if (voen.length > 0) {
      return schema.min(10, 'Vöen doğru daxil edilməyib');
    }
  }),
});
